var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('zf-group',[(_vm.energyConsumersMissing)?_c('add-energy-consumers-reminder',{attrs:{"tipsPerPage":_vm.numDisplayedTips}}):_vm._e(),_vm._l((_vm.tipsToDisplay),function(tip,index){return _c('tip-carousel-item',{key:index,attrs:{"tipsPerPage":_vm.numDisplayedTips,"showDetails":false,"tip":tip}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }